import { styled } from '@mui/system';
import { FormControl } from '@mui/material';
import { colors } from '../../theme/color-palette';

export const InlineLabelSelectFormControl = styled(FormControl)({
    flexDirection: 'row',
    alignItems: 'center',
    border: '1px solid #D5D6D8',
    borderRadius: '4px',
    display: 'flex',
    backgroundColor: colors.WHITE,
    transformOrigin: 'unset',
    width: 'min-content',
    '& fieldset': {
        display: 'none'
    },
    '& label': {
        lineHeight: 'normal',
        fontSize: '14px',
        position: 'relative',
        verticalAlign: 'baseline',
        '-webkit-transform': 'none',
        transform: 'none',
        paddingLeft: '16px',
    },
    ':hover': {
        backgroundColor: colors.LIGHT_GREY1
    },
    ':focus': {
        backgroundColor: colors.LIGHT_GREY1
    },
    ':active': {
        backgroundColor: colors.LIGHT_GREY1
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: colors.BLACK
    }
});